import React, { useState } from 'react';
import { Tooltip, TooltipTrigger } from '@adobe/react-spectrum';
import styles from '../FormField.module.scss';

interface ValidationTooltipProps {
  children: React.ReactElement;
  message: string;
  isDisabled: boolean;
  onAttemptClick?: () => void;
}

export const ValidationTooltip: React.FC<ValidationTooltipProps> = ({
  children,
  message,
  isDisabled,
  onAttemptClick
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      setShowTooltip(true);
      onAttemptClick?.();

      // Auto-hide tooltip after 3 seconds
      setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
    }
  };

  const handleMouseEnter = () => {
    if (isDisabled) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  if (!isDisabled) {
    return children;
  }

  return (
    <TooltipTrigger isOpen={showTooltip} delay={0}>
      <span
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{ display: 'contents' }}
      >
        {children}
      </span>
      <Tooltip variant="negative" placement="top">
        {message}
      </Tooltip>
    </TooltipTrigger>
  );
};
